import * as Sentry from '@sentry/browser'
import { BrowserTracing } from '@sentry/tracing'
import { NODE_ENV } from '~/utils/constants'

if (process.client && NODE_ENV !== 'local') {
  Sentry.init({
    environment: NODE_ENV,
    dsn: 'https://1bf03e1da56046de93937b692e6c29cc@o4504840211922944.ingest.sentry.io/4504840226078720',
    integrations: [new BrowserTracing(), new Sentry.Replay()],
    // TODO: Smarter sampling
    replaysOnErrorSampleRate: 1.0,
    tracesSampleRate: 1.0,
  })
}
